import logo from "../../assets/images/agra_logo2_cropped.png"
import { Icon } from '@iconify/react';
import { Link, useLocation } from 'react-router-dom/cjs/react-router-dom';
import {
    Dropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
} from 'reactstrap';
import React, { useState, useEffect } from 'react';

function LandingPageHeader() {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);

    const toggle = () => setDropdownOpen((prevState) => !prevState);
    const toggleMobileMenu = () => setMobileMenuOpen((prevState) => !prevState);

    const location = useLocation();

    // Function to determine active link
    const isActive = (paths) => paths.includes(location.pathname);

    // Update window width when resized
    useEffect(() => {
        const handleResize = () => {
            // Close mobile menu when resizing larger than desktop breakpoint
            if (window.innerWidth >= 1280) {
                setMobileMenuOpen(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <header className="bg-white px-4 py-2 shadow-md relative">
            <div className="container mx-auto flex justify-between items-center">
                {/* Logo - visible on all screen sizes */}
                <img src={logo} alt="AGRA Logo" className="h-8 sm:h-10 md:h-12"/>
                
                {/* Mobile menu button - visible on screens smaller than 1280px */}
                <button 
                    className="xl:hidden text-green-600 p-2"
                    onClick={toggleMobileMenu}
                    aria-label="Toggle menu"
                >
                    <Icon icon={mobileMenuOpen ? "material-symbols:close" : "material-symbols:menu"} width="24" height="24" />
                </button>

                {/* Desktop navigation - only visible on screens 1280px and larger */}
                <nav className="hidden xl:block">
                    <ul className="flex space-x-6">
                        <li>
                            <Link 
                                to="/" 
                                className={
                                    `text-green-600 flex items-center gap-1 p-1 rounded hover:bg-yellow-100
                                    ${isActive(['/']) ? 'bg-yellow-200' : ''}`
                                }
                            >
                                <Icon icon="material-symbols:home-outline" />
                                <span className="text-sm lg:text-base">Home</span>
                            </Link>
                        </li>
                        <li>
                            <Dropdown isOpen={dropdownOpen} toggle={toggle}>
                                <DropdownToggle className="bg-white border-none p-0" caret>
                                    <div 
                                        className={
                                            `text-green-600 flex items-center gap-1 rounded hover:bg-yellow-100 p-1
                                            ${isActive(['/home-tracker', '/home-policies']) ? 'bg-yellow-200' : ''}`
                                        }
                                    >
                                        <Icon icon="hugeicons:chart-breakout-square" />
                                        <span className="text-sm lg:text-base">E-tracker</span>
                                        <Icon icon="hugeicons:arrow-down-01" />
                                    </div>
                                </DropdownToggle>
                                <DropdownMenu>
                                    <DropdownItem header>Policies tracker</DropdownItem>
                                    <DropdownItem>
                                        <Link 
                                            to="/home-tracker" 
                                            className={
                                                `text-green-600 flex items-center gap-1 p-1 rounded hover:bg-yellow-100 
                                                ${isActive(['/home-tracker']) ? 'bg-yellow-200' : ''}`
                                            }
                                        >
                                            <Icon icon="hugeicons:chart-scatter" />
                                            <span className="text-sm lg:text-base">Dashboard</span>
                                        </Link>
                                    </DropdownItem>
                                    <DropdownItem divider />
                                    <DropdownItem>
                                        <Link 
                                            to="/home-policies" 
                                            className={
                                                `text-green-600 flex items-center gap-1 p-1 rounded hover:bg-yellow-100 
                                                ${isActive(['/home-policies']) ? 'bg-yellow-200' : ''}`
                                            }
                                        >
                                            <Icon icon="hugeicons:folder-01" />
                                            <span className="text-sm lg:text-base">Policy Directory</span>
                                        </Link>
                                    </DropdownItem>
                                </DropdownMenu>
                            </Dropdown>
                        </li>
                        <li>
                            <Link 
                                to="/home-benchmarking" 
                                className={
                                    `text-green-600 flex items-center gap-1 p-1 rounded hover:bg-yellow-100
                                    ${isActive(['/home-benchmarking']) ? 'bg-yellow-200' : ''}`
                                }
                            >
                                <Icon icon="hugeicons:chart-line-data-02" />
                                <span className="text-sm lg:text-base">Policy Benchmarking</span>
                            </Link>
                        </li>
                        <li>
                            <Link 
                                to="/home-landscape" 
                                className={
                                    `text-green-600 flex items-center gap-1 p-1 rounded hover:bg-yellow-100
                                    ${isActive(['/home-landscape']) ? 'bg-yellow-200' : ''}`
                                }
                            >
                                <Icon icon="ep:files" />
                                <span className="text-sm lg:text-base">Policy Landscaping</span>
                            </Link>
                        </li>
                        <li>
                            <Link 
                                to="/home-policy-updates" 
                                className={
                                    `text-green-600 flex items-center gap-1 p-1 rounded hover:bg-yellow-100 
                                    ${isActive(['/home-policy-updates']) ? 'bg-yellow-200' : ''}`
                                }>
                                    <Icon icon="hugeicons:news-01" />
                                    <span className="text-sm lg:text-base">Policies Updates</span>
                            </Link>
                        </li>
                        <li>
                            <Link 
                                to="/home-frequently-asked-questions" 
                                className={
                                    `text-green-600 flex items-center gap-1 p-1 rounded hover:bg-yellow-100
                                    ${isActive(['/home-frequently-asked-questions']) ? 'bg-yellow-200' : ''}`
                                }
                            >
                                <Icon icon="akar-icons:question" />
                                <span className="text-sm lg:text-base">FAQ</span>
                            </Link>
                        </li>
                    </ul>
                </nav>

                {/* Login button - only visible on xl screens and larger */}
                <Link to="/login" className="hidden xl:flex common-button m-0 text-base">
                    Login<Icon icon="material-symbols:login" className='ms-2' />
                </Link>
                
                {/* Mobile menu - visible when toggled on screens smaller than 1280px */}
                {mobileMenuOpen && (
                    <div className="absolute top-full left-0 right-0 bg-white shadow-lg z-50 py-4 xl:hidden">
                        <nav className="container mx-auto px-4">
                            <ul className="flex flex-col space-y-4">
                                <li>
                                    <Link 
                                        to="/" 
                                        className={
                                            `text-green-600 flex items-center gap-2 p-2 rounded hover:bg-yellow-100
                                            ${isActive(['/']) ? 'bg-yellow-200' : ''}`
                                        }
                                        onClick={toggleMobileMenu}
                                    >
                                        <Icon icon="material-symbols:home-outline" />
                                        Home
                                    </Link>
                                </li>
                                <li>
                                    <div 
                                        className={
                                            `text-green-600 flex items-center justify-between gap-2 p-2 rounded hover:bg-yellow-100
                                            ${isActive(['/home-tracker', '/home-policies']) ? 'bg-yellow-200' : ''}`
                                        }
                                        onClick={() => setMobileDropdownOpen(!mobileDropdownOpen)}
                                    >
                                        <div className="flex items-center gap-2">
                                            <Icon icon="hugeicons:chart-breakout-square" />
                                            E-tracker
                                        </div>
                                        <Icon icon={mobileDropdownOpen ? "hugeicons:arrow-up-01" : "hugeicons:arrow-down-01"} />
                                    </div>
                                    
                                    {mobileDropdownOpen && (
                                        <div className="pl-8 mt-2 space-y-2">
                                            <Link 
                                                to="/home-tracker" 
                                                className={
                                                    `text-green-600 flex items-center gap-2 p-2 rounded hover:bg-yellow-100 
                                                    ${isActive(['/home-tracker']) ? 'bg-yellow-200' : ''}`
                                                }
                                                onClick={() => {
                                                    setMobileDropdownOpen(false);
                                                    toggleMobileMenu();
                                                }}
                                            >
                                                <Icon icon="hugeicons:chart-scatter" />
                                                Dashboard
                                            </Link>
                                            <Link 
                                                to="/home-policies" 
                                                className={
                                                    `text-green-600 flex items-center gap-2 p-2 rounded hover:bg-yellow-100 
                                                    ${isActive(['/home-policies']) ? 'bg-yellow-200' : ''}`
                                                }
                                                onClick={() => {
                                                    setMobileDropdownOpen(false);
                                                    toggleMobileMenu();
                                                }}
                                            >
                                                <Icon icon="hugeicons:folder-01" />
                                                Policies Directory
                                            </Link>
                                        </div>
                                    )}
                                </li>
                                <li>
                                    <Link 
                                        to="/home-benchmarking" 
                                        className={
                                            `text-green-600 flex items-center gap-2 p-2 rounded hover:bg-yellow-100
                                            ${isActive(['/home-benchmarking']) ? 'bg-yellow-200' : ''}`
                                        }
                                        onClick={toggleMobileMenu}
                                    >
                                        <Icon icon="hugeicons:chart-line-data-02" />
                                        Benchmarking
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/home-landscape" 
                                        className={
                                            `text-green-600 flex items-center gap-2 p-2 rounded hover:bg-yellow-100
                                            ${isActive(['/home-landscape']) ? 'bg-yellow-200' : ''}`
                                        }
                                        onClick={toggleMobileMenu}
                                    >
                                        <Icon icon="ep:files" />
                                        Policy Landscaping
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/home-policy-updates" 
                                        className={
                                            `text-green-600 flex items-center gap-2 p-2 rounded hover:bg-yellow-100 
                                            ${isActive(['/home-policy-updates']) ? 'bg-yellow-200' : ''}`
                                        }
                                        onClick={toggleMobileMenu}
                                    >
                                        <Icon icon="hugeicons:news-01" />
                                        Policies Updates        
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/home-frequently-asked-questions" 
                                        className={
                                            `text-green-600 flex items-center gap-2 p-2 rounded hover:bg-yellow-100
                                            ${isActive(['/home-frequently-asked-questions']) ? 'bg-yellow-200' : ''}`
                                        }
                                        onClick={toggleMobileMenu}
                                    >
                                        <Icon icon="akar-icons:question" />
                                        FAQ
                                    </Link>
                                </li>
                                <li>
                                    <Link 
                                        to="/login" 
                                        className="w-full bg-green-600 text-white py-2 px-4 rounded flex items-center justify-center gap-2"
                                        onClick={toggleMobileMenu}
                                    >
                                        Login <Icon icon="material-symbols:login" />
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>
                )}
            </div>
        </header>
    );
}

export default LandingPageHeader;